import {
    ADD_PRICE_RULE,
    ADD_PRICE_RULE_ERROR,
    ADD_PRICE_RULE_SUCCESS,
    ASSIGN_TENANTS,
    ASSIGN_TENANTS_ERROR,
    ASSIGN_TENANTS_SUCCESS,
    DELETE_PRICE_RULE,
    DELETE_PRICE_RULE_ERROR,
    DELETE_PRICE_RULE_SUCCESS,
    GET_CATEGORIES_BY_GUEST_DISCOUNT,
    GET_CATEGORIES_BY_GUEST_DISCOUNT_ERROR,
    GET_CATEGORIES_BY_GUEST_DISCOUNT_SUCCESS,
    GET_GUEST_DISCOUNTS_BY_CATEGORY,
    GET_GUEST_DISCOUNTS_BY_CATEGORY_ERROR,
    GET_GUEST_DISCOUNTS_BY_CATEGORY_SUCCESS,
    GET_PRICE_RULE_DETAILS,
    GET_PRICE_RULE_DETAILS_ERROR,
    GET_PRICE_RULE_DETAILS_SUCCESS,
    GET_PRICE_RULES,
    GET_PRICE_RULES_ERROR,
    GET_PRICE_RULES_SUCCESS
} from '../types';

export const priceRuleReducer = (state, action) => {
    switch (action.type) {
        case GET_PRICE_RULES:
            return { ...state, priceRulesLoading: true, priceRulesError: false };
        case GET_PRICE_RULES_SUCCESS:
            return {
                ...state,
                priceRulesLoading: false,
                priceRules: action.payload,
                priceRulesError: false,
            };
        case GET_PRICE_RULES_ERROR:
            return {
                ...state,
                priceRulesLoading: false,
                priceRules: null,
                priceRulesError: true,
            };

        case ADD_PRICE_RULE:
            return { ...state, success: false, loading2: true, error: null };
        case ADD_PRICE_RULE_SUCCESS:
            return {
                ...state,
                loading2: false,
                success: action.payload.success,
                message: action.payload.message
            };
        case ADD_PRICE_RULE_ERROR:
            return {
                ...state,
                loading2: false,
                success: false,
                message: null,
                error: action.payload,
            };
        case ASSIGN_TENANTS:
            return { ...state, success: false, loading2: true, error: null };
        case ASSIGN_TENANTS_SUCCESS:
            return {
                ...state,
                loading2: false,
                priceRules: state.priceRules.map(priceRule =>
                    priceRule.id === action.payload.priceRuleId
                        ? { ...priceRule, assignedTenants: action.payload.tenants }
                        : priceRule
                ),
                success: action.payload.success,
                message: action.payload.message
            };
        case ASSIGN_TENANTS_ERROR:
            return {
                ...state,
                loading2: false,
                success: false,
                message: null,
                error: action.payload,
            };
        case GET_PRICE_RULE_DETAILS:
            return { ...state, priceRuleDetailsLoading: true, priceRuleDetailsError: false };
        case GET_PRICE_RULE_DETAILS_SUCCESS:
            return {
                ...state,
                priceRuleDetailsLoading: false,
                priceRuleDetails: action.payload,
                priceRuleDetailsError: false,
            };
        case GET_PRICE_RULE_DETAILS_ERROR:
            return {
                ...state,
                priceRuleDetailsLoading: false,
                priceRuleDetailsError: true,
                priceRuleDetails: null,
            };
        case DELETE_PRICE_RULE:
            return { ...state, success: false, loading2: true, error: null };
        case DELETE_PRICE_RULE_SUCCESS:
            return {
                ...state,
                loading2: false,
                success: action.payload.success,
                message: action.payload.message,
                priceRules: state.priceRules.filter(priceRule => priceRule.id !== action.payload.priceRuleId),
                guestDiscountsByCategory: state.guestDiscountsByCategory.filter(guestDiscount => guestDiscount.id !== action.payload.priceRuleId),
            };
        case DELETE_PRICE_RULE_ERROR:
            return {
                ...state,
                loading2: false,
                success: false,
                message: null,
                error: action.payload,
            };

        case GET_GUEST_DISCOUNTS_BY_CATEGORY:
            return {
                ...state,
                guestDiscountsByCategoryLoading: true,
                guestDiscountsByCategory: null,
                error: null,
            };
        case GET_GUEST_DISCOUNTS_BY_CATEGORY_SUCCESS:
            return {
                ...state,
                guestDiscountsByCategoryLoading: false,
                guestDiscountsByCategory: action.payload,
                error: null,
            };
        case GET_GUEST_DISCOUNTS_BY_CATEGORY_ERROR:
            return {
                ...state,
                guestDiscountsByCategoryLoading: false,
                guestDiscountsByCategory: null,
                error: action.payload,
            };
        case GET_CATEGORIES_BY_GUEST_DISCOUNT:
            return {
                ...state,
                categoriesByGuestDiscountLoading: true,
                categoriesByGuestDiscount: null,
                error: null,
            };
        case GET_CATEGORIES_BY_GUEST_DISCOUNT_SUCCESS:
            return {
                ...state,
                categoriesByGuestDiscountLoading: false,
                categoriesByGuestDiscount: action.payload,
                error: null,
            };
        case GET_CATEGORIES_BY_GUEST_DISCOUNT_ERROR:
            return {
                ...state,
                categoriesByGuestDiscountLoading: false,
                categoriesByGuestDiscount: null,
                error: action.payload,
            };
        default:
            return null;
    }
};
